import { render } from "./CommonRecipeFoodIdItem.vue?vue&type=template&id=3f4475c2&scoped=true&ts=true"
import script from "./CommonRecipeFoodIdItem.vue?vue&type=script&lang=ts"
export * from "./CommonRecipeFoodIdItem.vue?vue&type=script&lang=ts"

import "./CommonRecipeFoodIdItem.vue?vue&type=style&index=0&id=3f4475c2&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4475c2"]])

export default __exports__